import styled from '@emotion/styled';
import { useSelector, useDispatch } from 'shared/hooks';
import { sync } from 'shared/wizard/actions';
import { FlexContainer } from 'shared/containers';
import { Errors } from 'shared/inputs';
import { coverageOptions } from '../config';

const Label = styled.label(({ theme, active, error }) => {
  let border = `2px solid ${theme.cardColor}`;
  if (error) border = `1px solid ${theme.errorColor}`;
  if (active) border = `2px solid ${theme.primaryColor}`;

  return `
    position: relative;
    flex: 30% 0 0;

    input:focus + figure  {
      box-shadow: 0 0 4px ${theme.primaryColor};
    }

    figure {
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      background-color: ${theme.cardColor};
      border: ${border};
      box-shadow: ${!active ? '0 0 8px rgba(0, 0, 0, 0.12)' : null}; 
      border-radius: 10px;
      box-sizing: border-box;
      height: 100%;
      align-items: center;
      padding: 24px;
      cursor: pointer;
      box-sizing: border-box;
      border-radius: 10px;
    }

    figcaption {
      margin-top: 8px;
      max-width: 80px;
      color: ${theme.primaryColor};
      font-size: 14px;
      line-height: 18px;
      font-weight: 600;
      text-align: center;
    }

    svg {
      display: block;
      width: 32px;
      height: 32px;
      fill: ${theme.primaryColor};
    }
    
    @media ${theme.mobile} {
      figure {
        padding: 16px;
      }
    }
  `;
});

const InfoFooter = styled.div(({ theme }) => `
  font-size: 12px;
  color: ${theme.primaryFontColor};
  line-height: 18px;
  border-radius: 10px;
  background-color: ${theme.secondaryColor};
  box-sizing: border-box;
  padding: 16px;
  margin-top: 16px;

  > h3 {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 4px;
  }
`)

const SwitchCoverageType = () => {
  const dispatch = useDispatch();
  const {
    input: { coverageType },
    output: { errors },
  } = useSelector(state => state);
  const activeType = coverageOptions.find(type => type.value === coverageType)
  return (
    <>
      <FlexContainer css={{ marginBottom: '4px' }}>
        {coverageOptions.map(type => {
          const GraphIcon = type.svg;
          return (
            <Label
              key={type.value}
              active={coverageType === type.value}
              error={errors.coverageType}
              onClick={() => sync(dispatch)('coverageType', type.value)}
            >
              <input
                type="radio"
                name="coverageType"
                css={{ opacity: 0, position: 'absolute' }}
              />
              <figure>
                <GraphIcon />
                <figcaption>
                  {type.description}
                </figcaption>
              </figure>
            </Label>
          )
        })}
      </FlexContainer>
      <Errors errors={errors.coverageType} />
      {activeType && (
        <InfoFooter>
          <h3>{activeType.description.replace("-", "") + 'e dekking'}</h3>
          <p>{activeType.info}</p>
        </InfoFooter>
      )}
    </>
  )
}

export default SwitchCoverageType;
